import { useAccountStore, useSecurityStore, useUserStore } from '@/store'
import type { NavigationGuard } from 'vue-router'
import { LOGIN_ROUTE } from './constants'

// 确保页面声明需要账户数据时，进入前"已加载并且已选中账户"
const accountGuard: NavigationGuard = async (to, _, next) => {
  if (!to.meta?.requiresAccountData) return next()

  const accountStore = useAccountStore()

  try {
    // 未加载则初始化；已加载则跳过，避免并发与重复请求
    if (!accountStore.isLoaded) {
      await accountStore.init()
    }

    // 不仅要 loaded，还要确认真的"有选中的账户"
    if (!accountStore.hasSelectedAccount) {
      return next({ path: LOGIN_ROUTE.path })
    }

    return next()
  } catch {
    return next({ path: LOGIN_ROUTE.path })
  }
}

// const securityGuard: NavigationGuard = async (to, _from, next) => {
//   const securityCode = to.meta?.security_code as string | undefined
//   if (!securityCode) return next()
//   const store = useSecurityStore()
//   ;(to.meta as any).mfaRequired = await store.isRequired(securityCode)
//   next()
// }

const resolveGuards = [accountGuard]
export default resolveGuards
